import { FieldDiaryPage } from '@practium/features/field-diary';
import { useAuth } from '@practium/features/auth';
import { useFieldDiaryFarmsClient } from './hooks/useFieldDiaryFarmsClient';

export const FieldDiaryPageClient = () => {
	const { user } = useAuth();
	const { farms, isLoading } = useFieldDiaryFarmsClient(user?.role);

	return <FieldDiaryPage farms={farms} farmsLoading={isLoading} />;
};
